<template>
  <div class>
    <section class="d-flex flex-column h-full">
    <!-- <div class="fixed-header w-full"> -->
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      staticMode="true"
    ></TopAppBar>
    </section>

    <NoData v-if="isNoData"></NoData>

    <div class="pdt-16 pdl-8 pdr-8 pdb-20">
      <div
          v-for="(lesson, index) in listData"
          :key="index"
          class="lesson-item"
          @click="moveToLessonList(lesson.learnerId,lesson.lessonId,lesson.progressionId,lesson.isPossibleLearning)"
        >
          <div class="d-flex flex-column justify-content-between header-card mdc-card mdc-elevation--z3 mgb-16 pdt-12 pdb-16 mgl-8 mgr-8 bg-white pda-default">
            <div class="font-b  t-subtitle2 t-color-title l-spacing48">{{lesson.degreeName | charLength}}</div>
            <div class="d-flex pdt-16">
            <div class="pdr-8">
              <img
                src="images/portfolio/complete-red.svg"
                v-if="lesson.contentsType.value === 'EXAM_PAPER'"
                class="profile"
              />
              <img src="images/portfolio/uncomplete-green.svg" v-else class="profile min-w-40" />
              <div class="progress mgt-6">
                <div class="progress-body">
                  <div class="progress-sub" :style="`width:${lesson.rate}%;`"></div>
                </div>
                <div class="t-helper progress-text">{{$t('1838',{str:parseInt(lesson.rate)})}}</div>
              </div>
            </div>
            <div class="pdl-8 pdr-8 flex-grow-1">
              <div class="t-body1">
                {{lesson.name | charLength}}
                <div class="t-body3 t-color-gray2">
                  <span v-if="lesson && lesson.contentsType && lesson.contentsType.value=='VIDEO' && lesson.rate==100" style="text-transform: uppercase;">{{$t('1845')}}</span>
                  <span v-else-if="lesson && lesson.contentsType && lesson.contentsType.value=='VIDEO' && lesson.rate!=100" style="text-transform: uppercase;">{{$t('1839')}}</span>
                  <span v-else-if="lesson && lesson.contentsType && lesson.contentsType.value=='PDF'" style="text-transform: uppercase;">{{$t('1841')}}</span>
                  <span v-else-if="lesson && lesson.contentsType && lesson.contentsType.value=='HTML'" style="text-transform: uppercase;">{{$t('1842')}}</span>
                  <span v-else style="text-transform: uppercase;">{{$t(lesson.contentsType.translate)}}</span>
                  <!-- <span v-if="lesson.status.value === 'WAITING'">
                  </span> -->
                  <!-- <span v-else-if="lesson.status.value === 'OPENED'">
                    {{lesson.rate < 100 ? $t('144') : $t('146')}}
                  </span> -->
                  <!-- {{lesson.status.value}} -->
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      <infinite-loading  @infinite="fetchData" :identifier="infiniteId" spinner="spiral">
        <div slot="no-more" class="mgt-16"></div>
        <div slot="no-results" class="mgt-16"></div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import { MDCRipple } from "@material/ripple";
import { fileMixin } from "@/mixins/file.js";
import portfolioApi from "@/api/portfolioApi.js";
import NoData from "../common/NoDataBookMarkedLesson.vue";
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    NoData,
    InfiniteLoading,
    TopAppBar
  },
  filters:{
      charLength(value) {
          if(value.length>40){
              return value.substring(0,42)+"..."
          } else {
              return value
          }

      },
  },
  data() {
    return {
      status: "",
      leftBtnMethod: () => { this.$router.go(-1)},
      isNoData: false,
      campaignData: null,
      listData: [],
      currentPage: 1,
      totalPages: 1,
      infiniteId: +new Date(),
    };
  },
  mixins: [topAppBarMixin,fileMixin],
  computed: {},

  watch: {
    $route(to, from) {
      this.initData();
    },
  },

  mounted() {
    // 기본 파라미터 설정(set default parameter)
    this.setTopAppBarBackPortfolio(this.$t('1837'))
  },

  methods: {
    initData() {
      this.listData = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1
    },
    // 목록 데이터 로딩(get list data)
    fetchData($state) {
      let responseData = null;
      let responseDatas = null;
      if (this.totalPages >= this.currentPage) {
        portfolioApi
          .bookMarkedLessonList()
          .then((response) => {
            responseData = response.data.data;
            responseDatas = response.data;
            console.log('responseDataBooked=>',responseData);
            this.listData = this.listData.concat(responseDatas.data);
            this.currentPage++;
            this.totalPages = responseData.totalPages;

            if (responseData.length) {
              $state.loaded();
            } else {
              $state.complete();
            }

            if (this.listData.length > 0) {
              this.isNoData = false;
            } else {
              this.isNoData = true;
            }
          })
          .catch((err) => {
            //$state.error();
          });
      } else {
        $state.complete();
      }
    },

    moveToLessonList(learnerId,lessonId,progressionId,isPossibleLearning){
      if(isPossibleLearning===false){
        this.$alert({
              title: this.$t("1944"),
              content: this.$t("1945"),
              accept: this.$t("1946"),
            })
              .then(() => {
                //this.$router.push("/verificationcode");
              })
              .catch(() => {
                //this.$router.push('/login')
              });
      } else {
        localStorage.setItem('bookMarkLesson','setGoBackBookMarkLesson')
        this.$router.push('learn/'+learnerId+'/'+lessonId+'/lessonContents/'+progressionId+'?status=LEARNING')
        // this.$router.push({
        //   name: 'LearnView',
        //   params: {
        //       learnId: learnerId,
        //   },
        //   query: {portfolio:'bookmarklesson'}
        // })
      }
      
    },
    // 학습진행률 노출 상태 설정(set/toggle learning status graph)
    initProgressStatus(id) {
      _.map(this.listData, (o) => {
        o.id === id && o.progressViewStatus === false
          ? (o.progressViewStatus = true)
          : (o.progressViewStatus = false);
      });
    },
    
  },
};
</script>

<style scoped>
.mdc-elevation--z3 {
      border-radius: 4px;
      overflow: hidden;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
    background-color: #ffffff;
  }
  .tabs .tab {
    width: 50%;
    }
  .badge-chip{
    bottom: 0;
    right: 0;
    border-radius: 12px;
  }
  .two-column{
      flex-wrap:wrap;
  }
  .two-column > div{
     flex: 0 0 50%;
  }
  .count{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
  }
  :root {
  --customColor1: #ff847b;
  --customColor2: #b295e6;
  --customColor3: #ffad6e;
  --customColor4: #70cfc8;
    }
  
  .count-back{
    width: 48px;
    height: 48px;
    top: 0;
    left: 0;
    border-radius: 50%;
    opacity: 0.15;
  }
  .z-99{
      z-index: 99;
  }
  .bg-custom1{
    background: var(--customColor1);
  }
  .t-color-custom1{
      color: var(--customColor1);
  }
  .bg-custom2{
    background: var(--customColor2);
  }
  .t-color-custom2{
      color: var(--customColor2);
  }
  .bg-custom3{
    background: var(--customColor3);
  }
  .t-color-custom3{
      color: var(--customColor3);
  }
  .bg-custom4{
    background: var(--customColor4);
  }
  .t-color-custom4{
      color: var(--customColor4);
  }

  
  span.swiperImageIndicator {
    right: 8px;
    bottom: 8px;
    background: rgba(0, 0, 0, .18);
    border-radius: 30px;
  }
  .swiperSlideWrapper {
    width: 70%;
  }
  .swiperPercentWrapper {
    line-height: 0.5;
  }
  .swiperImageHolder img {
    max-height: 130px;
    object-fit: cover;
}


.cardInner{
  border-bottom: 1px solid rgba(172, 180, 190, 0.7);
}
.cardInner:last-child{
  border-bottom: none;
}
.swiper-slide {
      width: 232px;
}
.line-through:after {
    position: absolute;
    content: '';
    width: 100%;
    height: 1px;
    background: red;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
  @media (min-width:768px) {
    .bubble-image {
      width: 300px;
    }

    .swiperSlideWrapper {
      width: 350px;
    }
    .swiper-slide {
      width: auto;
    }
    .swiperImageHolder img {
       min-height: 235px;
      object-fit: cover;
    }
  }
</style>